module.exports = __webpack_public_path__ + "static/HTML-logo-c573ff5552d6da9a1d28ec4e27cd1445.png";